import { render, staticRenderFns } from "./PricingButton.vue?vue&type=template&id=42adbc02&"
import script from "./PricingButton.vue?vue&type=script&lang=js&"
export * from "./PricingButton.vue?vue&type=script&lang=js&"
import style0 from "./PricingButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports